import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { BaseWizardService } from "../base.wizard.service";
import { ApiService, InputDatastoreService, DialogService, CountryListService } from "@nrwl/common-lib";
import { AtaThresholdWizardStep } from "./ata.threshold.wizard.step";
import { BehaviorSubject } from "rxjs";
import { cloneDeep, get, last } from 'lodash';

@Injectable()
export class AtaThresholdWizardService extends BaseWizardService {
  thresholdData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  openNew:boolean;
  state:ActivatedRoute;
  currentParam:any;
  constructor(
    dataApiService:ApiService,
    state: ActivatedRoute,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService) {
    super(dataApiService, inputDatastoreService, countryListService, dialogService);
    this.state = state;
    this.stepClass = AtaThresholdWizardStep;
    this.openNew = false;
  }

 //------------------------------------------------ Wizard control ----------------------------------------------------

 openWizard(
    wizardId,
    wizardConfig,
    defaultParamsById = {},
    onSuccess = () => {},
    onFail = () => {}
 ) {
   super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
   if(this.editMode) {
    this._setOutputForEditMode(defaultParamsById);
    this.currentStep = last(this.steps);
    const appId = get(defaultParamsById, 'id');
    this.dataUrl = `${this.dataUrl}/${appId}`;
  }
 }
setSitesAndApps (value: any){
  this.thresholdData.next(value);
}

_setDefaultParams(step, targetOutput, defaultParamsById: any = {}) {
  super._setDefaultParams(step, targetOutput, defaultParamsById);
}
onFinish() {
  this.currentStep.onNext();
  this.dirtyFlag = false;
  const output = this._getFormatOutput();
  this.lastSubmittedOutput = cloneDeep(output);
  const responseProcessed = this._saveRequest(output, null);

  responseProcessed.subscribe(
    result => {
      this.currentStep = this.finishingStep;
    }
  );
  return responseProcessed;
}

showExitInsteadOfClose() {
  if (this.isFinishingStep() && (this.requestFailed || this.errorMessage)) {
    return true;
  }
  return false;
}
retrySaveRequest() {
  return super._saveRequest(this.lastSubmittedOutput, null);
}
}